/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Skip_TitleInputs */



/**
* | output |
* | --- |
* | "Skip/Ignore" |
*
* @param {Spellcheck_Skip_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_skip_title = /** @type {((inputs?: Spellcheck_Skip_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Skip_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überspringen/Ignorieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salta/Ignora")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пропустить/Игнорировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Saltar/Ignorar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跳过/忽略")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スキップ/無視")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छोड़ें/अनदेखा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar/Pular")
	return /** @type {LocalizedString} */ ("Skip/Ignore")
});